<template>
 <div class="bump">

    <v-data-table
      :headers="tmd"
      :items="totalMarket"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="rtdd"
      :items="techDev"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="trcl"
      :items="regComp"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="tmna"
      :items="totManage"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="totres"
      :items="totRes"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="msub"
      :items="monTot"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        <td class="text-xs-right">{{ props.item.two }}</td>
        <td class="text-xs-right">{{ props.item.three }}</td>
        <td class="text-xs-right">{{ props.item.four }}</td>
        <td class="text-xs-right">{{ props.item.five }}</td>
        <td class="text-xs-right">{{ props.item.six }}</td>
        <td class="text-xs-right">{{ props.item.seven }}</td>
        <td class="text-xs-right">{{ props.item.eight }}</td>
        <td class="text-xs-right">{{ props.item.nine }}</td>
        <td class="text-xs-right">{{ props.item.ten }}</td>
        <td class="text-xs-right">{{ props.item.eleven }}</td>
        <td class="text-xs-right">{{ props.item.twelve }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="yearOne"
      :items="yrTot"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    </div>
</template>

<script>
export default {
  data() {
    return {
      tmd: [
        {
          text: 'Total Market Development',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' },
      ],
      rtdd: [
        {
          text: 'R & D - Technical Design and Development',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' }
      ],
      trcl: [
        {
          text: 'Regulatory, Compliance & Legal',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' }
      ],
      tmna: [
        {
          text: 'Total Management & Admin',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' }
      ],
      totres: [
        {
          text: 'Total Reserve',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' }
      ],
      msub: [
        {
          text: 'Monthly Subtotal',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Month 1', value: 'one', sortable: false, align: 'right' },
        { text: 'Month 2', value: 'two', sortable: false, align: 'right' },
        { text: 'Month 3', value: 'three', sortable: false, align: 'right' },
        { text: 'Month 4', value: 'four', sortable: false, align: 'right' },
        { text: 'Month 5', value: 'five', sortable: false, align: 'right' },
        { text: 'Month 6', value: 'six', sortable: false, align: 'right' },
        { text: 'Month 7', value: 'seven', sortable: false, align: 'right' },
        { text: 'Month 8', value: 'eight', sortable: false, align: 'right' },
        { text: 'Month 9', value: 'nine', sortable: false, align: 'right' },
        { text: 'Month 10', value: 'ten', sortable: false, align: 'right' },
        { text: 'Month 11', value: 'eleven', sortable: false, align: 'right' },
        { text: 'Month 12', value: 'twelve', sortable: false, align: 'right' }
      ],
      yearOne: [
        {
          text: 'Year 1 Total Costs',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 1', value: 'one', sortable: false, align: 'right' }
      ],
      totalMarket: [
        {
          value: false,
          name: 'Total Personnel (Salaries)',
          notes: '',
          one: '$21,680.00',
          two: '$21,680.00',
          three: '$21,680.00',
          four: '$21,680.00',
          five: '$31,680.00',
          six: '$31,680.00',
          seven: '$31,680.00',
          eight: '$31,680.00',
          nine: '$41,680.00',
          ten: '$41,680.00',
          eleven: '$41,680.00',
          twelve: '$41,680.00'
        },
        {
          value: false,
          name: '- Karim',
          notes: '',
          one: '$5,000.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: '- Drago',
          notes: '',
          one: '$2,400.00',
          two: '$2,400.00',
          three: '$2,400.00',
          four: '$2,400.00',
          five: '$2,400.00',
          six: '$2,400.00',
          seven: '$2,400.00',
          eight: '$2,400.00',
          nine: '$2,400.00',
          ten: '$2,400.00',
          eleven: '$2,400.00',
          twelve: '$2,400.00'
        },
        {
          value: false,
          name: '- Rob',
          notes: '',
          one: '$6,000.00',
          two: '$6,000.00',
          three: '$6,000.00',
          four: '$6,000.00',
          five: '$6,000.00',
          six: '$6,000.00',
          seven: '$6,000.00',
          eight: '$6,000.00',
          nine: '$6,000.00',
          ten: '$6,000.00',
          eleven: '$6,000.00',
          twelve: '$6,000.00'
        },
        {
          value: false,
          name: '- Kyle ',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00',
          six: '$0.00',
          seven: '$0.00',
          eight: '$0.00',
          nine: '$0.00',
          ten: '$0.00',
          eleven: '$0.00',
          twelve: '$0.00'
        },
        {
          value: false,
          name: '- Jeramey',
          notes: '',
          one: '$2,080.00',
          two: '$2,080.00',
          three: '$2,080.00',
          four: '$2,080.00',
          five: '$2,080.00',
          six: '$2,080.00',
          seven: '$2,080.00',
          eight: '$2,080.00',
          nine: '$2,080.00',
          ten: '$2,080.00',
          eleven: '$2,080.00',
          twelve: '$2,080.00'
        },
        {
          value: false,
          name: '- Oren',
          notes: '',
          one: '$1,200.00',
          two: '$1,200.00',
          three: '$1,200.00',
          four: '$1,200.00',
          five: '$1,200.00',
          six: '$1,200.00',
          seven: '$1,200.00',
          eight: '$1,200.00',
          nine: '$1,200.00',
          ten: '$1,200.00',
          eleven: '$1,200.00',
          twelve: '$1,200.00'
        },
        {
          value: false,
          name: '- Jason',
          notes: '',
          one: '$5,000.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: '- Additional Team',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$10,000.00',
          six: '$10,000.00',
          seven: '$10,000.00',
          eight: '$10,000.00',
          nine: '$20,000.00',
          ten: '$20,000.00',
          eleven: '$20,000.00',
          twelve: '$20,000.00'
        },
        {
          value: false,
          name: 'Advertising & Marketing',
          notes: '',
          one: '$36,500.00',
          two: '$36,500.00',
          three: '$36,500.00',
          four: '$36,500.00',
          five: '$36,500.00',
          six: '$36,500.00',
          seven: '$36,500.00',
          eight: '$36,500.00',
          nine: '$36,500.00',
          ten: '$36,500.00',
          eleven: '$36,500.00',
          twelve: '$36,500.00'
        },
        {
          value: false,
          name: 'PR Expenses',
          notes: '',
          one: '$6,000.00',
          two: '$6,000.00',
          three: '$6,000.00',
          four: '$6,000.00',
          five: '$6,000.00',
          six: '$6,000.00',
          seven: '$6,000.00',
          eight: '$6,000.00',
          nine: '$6,000.00',
          ten: '$6,000.00',
          eleven: '$6,000.00',
          twelve: '$6,000.00'
        },
        {
          value: false,
          name: 'Event + Travel Costs',
          notes: '',
          one: '$16,500.00',
          two: '$16,500.00',
          three: '$16,500.00',
          four: '$16,500.00',
          five: '$16,500.00',
          six: '$16,500.00',
          seven: '$20,000.00',
          eight: '$20,000.00',
          nine: '$20,000.00',
          ten: '$20,000.00',
          eleven: '$20,000.00',
          twelve: '$20,000.00'
        },
        {
          value: false,
          name: 'Community Management (Moderation & forum posters)',
          notes: '',
          one: '$1,500.00',
          two: '$1,500.00',
          three: '$1,500.00',
          four: '$1,500.00',
          five: '$1,500.00',
          six: '$1,500.00',
          seven: '$1,500.00',
          eight: '$1,500.00',
          nine: '$1,500.00',
          ten: '$1,500.00',
          eleven: '$1,500.00',
          twelve: '$1,500.00'
        },
        {
          value: false,
          name: 'Professional Services (MLG)',
          notes: '',
          one: '$10,000.00',
          two: '$40,000.00',
          three: '$40,000.00',
          four: '$40,000.00',
          five: '$40,000.00',
          six: '$10,000.00',
          seven: '$10,000.00',
          eight: '$10,000.00',
          nine: '$10,000.00',
          ten: '$10,000.00',
          eleven: '$10,000.00',
          twelve: '$10,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$113,860.00',
          two: '$143,860.00',
          three: '$143,860.00',
          four: '$143,860.00',
          five: '$163,860.00',
          six: '$133,860.00',
          seven: '$133,860.00',
          eight: '$137,360.00',
          nine: '$137,360.00',
          ten: '$157,360.00',
          eleven: '$157,360.00',
          twelve: '$157,360.00'
        }
      ],
      //R & D - Technical Design and Development
      techDev: [
        {
          value: false,
          name: 'Blockchain Advisor, Lead Architect',
          notes: '',
          one: '$0.00',
          two: '$25,000.00',
          three: '$25,000.00',
          four: '$25,000.00',
          five: '$10,000.00',
          six: '$10,000.00',
          seven: '$10,000.00',
          eight: '$10,000.00',
          nine: '$10,000.00',
          ten: '$10,000.00',
          eleven: '$10,000.00',
          twelve: '$10,000.00'
        },
        {
          value: false,
          name: 'Distributed Storage Advisor',
          notes: '',
          one: '$0.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$1,000.00',
          six: '$1,000.00',
          seven: '$1,000.00',
          eight: '$1,000.00',
          nine: '$10,000.00',
          ten: '$10,000.00',
          eleven: '$10,000.00',
          twelve: '$10,000.00'
        },
        {
          value: false,
          name: 'Economic Advisor',
          notes: '',
          one: '$0.00',
          two: '$50,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$0.00',
          seven: '$0.00',
          eight: '$0.00',
          nine: '$0.00',
          ten: '$0.00',
          eleven: '$0.00',
          twelve: '$0.00'
        },
        {
          value: false,
          name: 'Cryptographic (Maths) Advisor',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$30,000.00',
          four: '$4,000.00',
          five: '$4,000.00',
          six: '$6,000.00',
          seven: '$6,000.00',
          eight: '$6,000.00',
          nine: '$6,000.00',
          ten: '$6,000.00',
          eleven: '$6,000.00',
          twelve: '$6,000.00'
        },
        {
          value: false,
          name: 'Semantics (Ontology) Advisor (contingency)',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$25,000.00',
          four: '$4,000.00',
          five: '$4,000.00',
          six: '$4,000.00',
          seven: '$4,000.00',
          eight: '$4,000.00',
          nine: '$10,000.00',
          ten: '$10,000.00',
          eleven: '$10,000.00',
          twelve: '$10,000.00'
        },
        {
          value: false,
          name: 'Market Research (Group testing & Web Scraping)',
          notes: '',
          one: '$8,000.00',
          two: '$8,000.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00',
          six: '$0.00',
          seven: '$0.00',
          eight: '$0.00',
          nine: '$0.00',
          ten: '$0.00',
          eleven: '$0.00',
          twelve: '$0.00'
        },
        {
          value: false,
          name: 'Machine Learning Advisors & Data Exploration ',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$50,000.00',
          four: '$10,000.00',
          five: '$10,000.00',
          six: '$20,000.00',
          seven: '$20,000.00',
          eight: '$20,000.00',
          nine: '$20,000.00',
          ten: '$20,000.00',
          eleven: '$20,000.00',
          twelve: '$20,000.00'
        },
        {
          value: false,
          name: 'Tech Audit Reports & Expert Validation (Cryptography)',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00',
          six: '$0.00',
          seven: '$0.00',
          eight: '$0.00',
          nine: '$0.00',
          ten: '$0.00',
          eleven: '$0.00',
          twelve: '$0.00'
        },
        {
          value: false,
          name: 'Scanner Development',
          notes: '',
          one: '$65,000.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00',
          six: '$0.00',
          seven: '$0.00',
          eight: '$0.00',
          nine: '$0.00',
          ten: '$0.00',
          eleven: '$0.00',
          twelve: '$0.00'
        },
        {
          value: false,
          name: 'Application Prototyping & Scanner Development',
          notes: '',
          one: '$2,500.00',
          two: '$2,500.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: 'App (UI/UX), web redesign & progressive app development',
          notes: '',
          one: '$23,500.00',
          two: '$23,500.00',
          three: '$23,500.00',
          four: '$23,500.00',
          five: '$23,500.00',
          six: '$23,500.00',
          seven: '$10,000.00',
          eight: '$10,000.00',
          nine: '$20,000.00',
          ten: '$20,000.00',
          eleven: '$20,000.00',
          twelve: '$20,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$99,000.00',
          two: '$84,000.00',
          three: '$138,500.00',
          four: '$51,500.00',
          five: '$51,500.00',
          six: '$58,500.00',
          seven: '$45,000.00',
          eight: '$45,000.00',
          nine: '$61,000.00',
          ten: '$61,000.00',
          eleven: '$61,000.00',
          twelve: '$61,000.00'
        }
      ],
      regComp: [
        {
          value: false,
          name: 'Token Sale Infastructure & Preperation',
          notes: '',
          one: '$0.00',
          two: '$0.00',
          three: '$0.00',
          four: '$0.00',
          five: '$0.00',
          six: '$0.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: 'Legal Compliance (Website, OM, White Paper)',
          notes: '',
          one: '$5,000.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$21,500.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$15,000.00',
          eight: '$15,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: 'Accounting Fees',
          notes: '',
          one: '$1,500.00',
          two: '$1,500.00',
          three: '$1,500.00',
          four: '$1,500.00',
          five: '$1,500.00',
          six: '$1,500.00',
          seven: '$1,500.00',
          eight: '$1,500.00',
          nine: '$1,500.00',
          ten: '$1,500.00',
          eleven: '$1,500.00',
          twelve: '$1,500.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$6,500.00',
          two: '$6,500.00',
          three: '$6,500.00',
          four: '$23,000.00',
          five: '$6,500.00',
          six: '$6,500.00',
          seven: '$21,500.00',
          eight: '$21,500.00',
          nine: '$11,500.00',
          ten: '$11,500.00',
          eleven: '$11,500.00',
          twelve: '$11,500.00'
        }
      ],
      totManage: [
        {
          value: false,
          name: 'Salaries',
          notes: '',
          one: '$2,500.00',
          two: '$2,500.00',
          three: '$2,500.00',
          four: '$2,500.00',
          five: '$2,500.00',
          six: '$2,500.00',
          seven: '$2,500.00',
          eight: '$2,500.00',
          nine: '$2,500.00',
          ten: '$2,500.00',
          eleven: '$2,500.00',
          twelve: '$2,500.00'
        },
        {
          value: false,
          name: 'Office Space (Toronto)',
          notes: '',
          one: '$3,500.00',
          two: '$3,500.00',
          three: '$3,500.00',
          four: '$3,500.00',
          five: '$3,500.00',
          six: '$3,500.00',
          seven: '$3,500.00',
          eight: '$3,500.00',
          nine: '$3,500.00',
          ten: '$3,500.00',
          eleven: '$3,500.00',
          twelve: '$3,500.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$6,000.00',
          two: '$6,000.00',
          three: '$6,000.00',
          four: '$6,000.00',
          five: '$6,000.00',
          six: '$6,000.00',
          seven: '$6,000.00',
          eight: '$6,000.00',
          nine: '$6,000.00',
          ten: '$6,000.00',
          eleven: '$6,000.00',
          twelve: '$6,000.00'
        }
      ],
      totRes: [
        {
          value: false,
          name: 'Services & Supplies',
          notes: '',
          one: '$5,000.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        },
        {
          value: false,
          name: '',
          notes: '',
          one: '$5,000.00',
          two: '$5,000.00',
          three: '$5,000.00',
          four: '$5,000.00',
          five: '$5,000.00',
          six: '$5,000.00',
          seven: '$5,000.00',
          eight: '$5,000.00',
          nine: '$5,000.00',
          ten: '$5,000.00',
          eleven: '$5,000.00',
          twelve: '$5,000.00'
        }
      ],
      monTot: [
        {
          value: false,
          name: '',
          notes: '',
          one: '$230,360.00',
          two: '$245,360.00',
          three: '$299,860.00',
          four: '$229,360.00',
          five: '$232,860.00',
          six: '$209,860.00',
          seven: '$214,860.00',
          eight: '$214,860.00',
          nine: '$240,860.00',
          ten: '$240,860.00',
          eleven: '$240,860.00',
          twelve: '$240,860.00'
        }
      ],
      yrTot: [
        {
          value: false,
          name: '',
          one: '$2,656,660.00'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>